import { useSiteConfig } from "@/components/SiteConfig";
import { MessageCircle } from "lucide-react";

export function FloatingWhatsApp({ message = "Olá! Vim pelo site GIRO+SAÚDE e gostaria de mais informações." }) {
  const cfg = useSiteConfig();
  const wa = cfg?.contact?.whatsapp;
  if (!wa) return null;
  const digits = wa.replace(/\D/g, "");
  const href = `https://wa.me/55${digits}?text=${encodeURIComponent(message)}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      data-testid="floating-whatsapp"
      aria-label="Falar no WhatsApp"
      className="fixed bottom-5 right-5 z-40 group flex items-center gap-2 pl-4 pr-5 py-3 rounded-full bg-[#25D366] text-white shadow-lg hover:shadow-xl hover:-translate-y-0.5 transition"
    >
      <span className="relative flex w-6 h-6 items-center justify-center">
        <span className="absolute inset-0 rounded-full bg-white/30 animate-ping"/>
        <MessageCircle className="w-5 h-5 relative"/>
      </span>
      <span className="hidden sm:block text-sm font-semibold whitespace-nowrap">Fale conosco</span>
    </a>
  );
}
